export interface CountryCode {
  code: string
  iso: string
}

/** Prefijos telefónicos para el campo SMS del formulario de Brevo. */
export const countryCodes: CountryCode[] = [
  { code: '+54', iso: 'AR' },
  { code: '+591', iso: 'BO' },
  { code: '+55', iso: 'BR' },
  { code: '+56', iso: 'CL' },
  { code: '+57', iso: 'CO' },
  { code: '+506', iso: 'CR' },
  { code: '+53', iso: 'CU' },
  { code: '+593', iso: 'EC' },
  { code: '+503', iso: 'SV' },
  { code: '+34', iso: 'ES' },
  { code: '+1', iso: 'US' },
  { code: '+502', iso: 'GT' },
  { code: '+504', iso: 'HN' },
  { code: '+52', iso: 'MX' },
  { code: '+505', iso: 'NI' },
  { code: '+507', iso: 'PA' },
  { code: '+595', iso: 'PY' },
  { code: '+51', iso: 'PE' },
  { code: '+1787', iso: 'PR' },
  { code: '+1809', iso: 'DO' },
  { code: '+598', iso: 'UY' },
  { code: '+58', iso: 'VE' },
  { code: '+1', iso: 'CA' },
  { code: '+44', iso: 'GB' },
  { code: '+33', iso: 'FR' },
  { code: '+39', iso: 'IT' },
  { code: '+351', iso: 'PT' },
  { code: '+49', iso: 'DE' },
  { code: '+31', iso: 'NL' },
  { code: '+32', iso: 'BE' },
  { code: '+41', iso: 'CH' },
  { code: '+43', iso: 'AT' },
  { code: '+46', iso: 'SE' },
  { code: '+47', iso: 'NO' },
  { code: '+45', iso: 'DK' },
  { code: '+358', iso: 'FI' },
  { code: '+353', iso: 'IE' },
  { code: '+48', iso: 'PL' },
  { code: '+30', iso: 'GR' },
  { code: '+40', iso: 'RO' },
  { code: '+90', iso: 'TR' },
  { code: '+212', iso: 'MA' },
  { code: '+972', iso: 'IL' },
  { code: '+971', iso: 'AE' },
  { code: '+61', iso: 'AU' },
  { code: '+64', iso: 'NZ' },
  { code: '+81', iso: 'JP' },
  { code: '+82', iso: 'KR' },
  { code: '+86', iso: 'CN' },
  { code: '+91', iso: 'IN' },
  { code: '+63', iso: 'PH' },
  { code: '+27', iso: 'ZA' },
]
